import { WEEKDAYS, MAX_MONTHS, MONTH, STATE_MONTHS } from '@app/src/common/datePicker/state/calendar/constants';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { DateType } from '@app/src/common/datePicker/types/Date';

export const getPrevDate = ({ month, year }: DateType): DateType => {
  if(month > MONTH.FIRST) {
    return {
      month: month - 1,
      year
    }
  }
  return {
    month: MONTH.LAST,
    year: year - 1
  }
};

export const getNextDate = ({ month, year }: DateType): DateType => {
  if(month < MONTH.LAST) {
    return {
      month: month + 1,
      year
    };
  }
  return {
    month: MONTH.FIRST,
    year: year + 1
  };
};


const getTotalDays = (month: number, year: number): number => {
  return 32 - new Date(year, month, 32).getDate();
};

const getFirstDay = (month: number, year: number): number => {
  const firstDay: number = new Date(year, month).getDay() - 1;
  return firstDay < 0 ? 6 : firstDay;
};

export const getCalendar = (printData) => {
  const { id } = printData;
  const calendar = [];
  let month = new Date().getMonth();
  let year = new Date().getFullYear();
  for(let i = 1; i <= MAX_MONTHS; i++) {
    calendar.push(getDaysByMonth(month, year, i-1));
    if (month % 11 === 0) {
      year++;
    }
    month++;
  }
  return getValidateDateByPrint[id](calendar, printData);
};

const validPosition = (currentMonth: number) => currentMonth % 12;

const getDaysByMonth = (currentMonth: number, year: number, positionMonth: number): DayType[] => {
  const daysMonth = [];
  let initialDay: number = 1;
  const prevMonthDay: Date = new Date(year, currentMonth, 1 - new Date(year, currentMonth, 1).getDay());
  let daysPrevMonth = prevMonthDay.getDate();
  const rowsByMonth: number = 6;
  const weekDays: number = 6;
  const firstDay: number = getFirstDay(currentMonth, year);
  let dayNextMonth = 1;

  for(let i = 0; i < rowsByMonth; i++) {
    for(let j = 0; j <= weekDays; j++) {
      if(i === 0 && j < firstDay) {
        const daysPrev = ++daysPrevMonth;
        daysMonth.push({
          stateMonth: STATE_MONTHS.PREV,
          dayMonth: daysPrev,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.PREV, positionMonth, daysPrev),
          dayWeekPos: j,
          otherDayMonth: true,
          month: (validPosition(currentMonth) === 0) ? 11 : validPosition(currentMonth) - 1,
          year: validPosition(currentMonth) === 0 ? year - 1 : year
        });
        continue;
      }
      if (initialDay > getTotalDays(currentMonth, year)) {
        const daysNext = dayNextMonth++;
        daysMonth.push({
          stateMonth: STATE_MONTHS.NEXT,
          dayMonth: daysNext,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.NEXT, positionMonth, daysNext),
          dayWeekPos: j,
          otherDayMonth: true,
          month: (validPosition(currentMonth) === 11) ? 0 : validPosition(currentMonth) + 1,
          year: (validPosition(currentMonth) === 11) ? year + 1 : year
        });
        continue;
      }
      daysMonth.push({
        dayMonth: initialDay,
        stateMonth: STATE_MONTHS.CURRENT,
        dayName: WEEKDAYS[j],
        disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.CURRENT, positionMonth, initialDay),
        dayWeekPos: j,
        otherDayMonth: false,
        month: validPosition(currentMonth),
        year: year
      });
      initialDay++;
    }
  }
  return daysMonth;
};

const setDisabledDaysByBehaviorCalendar = (stateMonth: string, posMonth: number, dayMonth: number) => {
  const currentDay = new Date().getDate();
  if (posMonth === 0) {
    if (dayMonth < currentDay && stateMonth === STATE_MONTHS.CURRENT) {
      return true;
    }
    if (stateMonth === STATE_MONTHS.PREV) {
      return true;
    }
  }
  if (posMonth === MAX_MONTHS - 1 && stateMonth === STATE_MONTHS.NEXT) {
      return true;
  }
  return false;
};

const isToday = (day: DayType) => {
  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  return day.dayMonth === currentDay && day.month === currentMonth && day.year === currentYear;
};

const validateDatePublicationTimeTalanD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSundayPosition = 0;
        for (let i = currentDayPosition; i < 6; i++) {
          nextSundayPosition++;
        }
        const positionResult = j + nextSundayPosition;
        if (
          !calendar[i][positionResult].disabled &&
          calendar[i][j].dayWeekPos <= closeDay
        ) {
          if (calendar[i][j].dayWeekPos === closeDay && currentHour >= closeHour) {
            calendar[i][positionResult].disabled = true;
          } else {
            calendar[i][positionResult].disabled = false;
            }
        } else {
          calendar[i][positionResult].disabled = true;
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeComercioMS = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }
      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT) &&
        closeDay.includes(currentDayPosition)
      ) {

        for (let count=0; count < closeDay.length; count++) {
          if (currentDayPosition === closeDay[count]) {
            const currentCloseHour = closeHour[count];
            if (closeDay[count] > allowDay[count]) {
              if (!calendar[i][j + 2].disabled && currentHour >= currentCloseHour) {
                calendar[i][j + 2].disabled = true;
              }
            } else {
              if (!calendar[i][j + 1].disabled && currentHour >= currentCloseHour) {
                calendar[i][j + 1].disabled = true;
              }
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeComercioD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSundayPosition = 0;
        for (let i = currentDayPosition; i < 6; i++) {
          nextSundayPosition++;
        }
        const positionResult = j + nextSundayPosition;
        if (
          !calendar[i][positionResult].disabled &&
          calendar[i][j].dayWeekPos <= closeDay
        ) {
          if (calendar[i][j].dayWeekPos === closeDay && currentHour >= closeHour) {
            calendar[i][positionResult].disabled = true;
          } else {
            calendar[i][positionResult].disabled = false;
          }
        } else {
          calendar[i][positionResult].disabled = true;
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanS = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSaturdayPosition = 0;
        for (let i = currentDayPosition; i < 5; i++) {
          nextSaturdayPosition++;
        }
        const positionResult = j + nextSaturdayPosition;
        if (currentDayPosition >= closeDay) {
          if(!calendar[i][positionResult].disabled) {
            if (currentDayPosition === closeDay) {
              if (currentHour >= closeHour) {
                calendar[i][positionResult].disabled = true;
              } else {
                calendar[i][positionResult].disabled = false;
              }
            } else {
              calendar[i][positionResult].disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let pos = allowDay.indexOf(currentDayPosition);
        let currentDay;
        let acBefore = pos;
        let acAfter = 1;
        for(let c=0; c<allowDay.length; c++) {
          if (c<pos) {
            currentDay = calendar[i][j - acBefore];
            if (closeDay[c] > currentDayPosition) {
              currentDay = calendar[i][j - acBefore + 7];
            }
            acBefore--;
          }
          if (c===pos) {
            currentDay = calendar[i][j];
          }
          if (c>pos) {
            currentDay = calendar[i][j + acAfter];
            acAfter++;
          }
          if (!currentDay.disabled) {
            if (currentDayPosition > closeDay[c]) {
              currentDay.disabled = true;
            }
            if (currentDayPosition === closeDay[c] && currentHour >= closeHour[c]) {
              currentDay.disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporSD = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT) &&
        closeDay.includes(currentDayPosition)
      ) {
        let count = closeDay.indexOf(currentDayPosition);
        let ac = 0;
        for(let c=count; c >=0; c--) {
          const currentCloseHour = closeHour[c];
          if (closeDay[c] <= currentDayPosition) {
            const currentDay = calendar[i][j + 2 + ac];
            if (closeDay[c] === currentDayPosition) {
              if (!currentDay.disabled && currentHour >= currentCloseHour) {
                currentDay.disabled = true;
              }
            } else {
              if (!currentDay.disabled) {
                currentDay.disabled = true;
              }
            }
            ac--;
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonhhth !== STATE_MONTHS.NEXT)
      ) {
        let pos = allowDay.indexOf(currentDayPosition);
        let currentDay;
        let acBefore = pos;
        let acAfter = 1;
        for(let c=0; c<allowDay.length; c++) {
          if (c<pos) {
            currentDay = calendar[i][j - acBefore];
            if (closeDay[c] > currentDayPosition) {
              currentDay = calendar[i][j - acBefore + 7];
            }
            acBefore--;
          }
          if (c===pos) {
            currentDay = calendar[i][j];
          }
          if (c>pos) {
            currentDay = calendar[i][j + acAfter];
            acAfter++;
          }
          if (!currentDay.disabled) {
            if (currentDayPosition > closeDay[c]) {
              currentDay.disabled = true;
            }
            if (currentDayPosition === closeDay[c] && currentHour >= closeHour[c]) {
              currentDay.disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

export const getValidateDateByPrint = {
  1: validateDatePublicationTimeComercioD,
  2: validateDatePublicationTimeTalanD,
  3: validateDatePublicationTimeComercioMS,
  4: validateDatePublicationTimeTalanS,
  5: validateDatePublicationTimeTalanLV,
  6: validateDatePublicationTimeDeporSD,
  7: validateDatePublicationTimeDeporLV
};

